const delay = async (ms) => {
    return new Promise((res, rej) => {
      setTimeout(() => {
        res("done")
      }, ms)
    })
  }
  export default delay